import { createSelector, createStateHook, type HookStateFunction } from 'react-sweet-state';

import type { FormDataPublic } from '../../../../common/types/fields/form-field-data';
import type { ScreenTabsDataPublic } from '../../../../common/types/screen-tabs';
import { store } from '../../main';
import type { IssueAdjustmentsState } from '../../types';

import type { CurrentPublicState } from './types';

const stableEmpty = {};
const stableEmptyScreenTabsArrray: ScreenTabsDataPublic = [];

const selectCurrentFormState = createSelector<
	IssueAdjustmentsState,
	undefined,
	CurrentPublicState,
	Readonly<FormDataPublic | null>,
	ScreenTabsDataPublic | null
>(
	(state) => state.formData,
	(state) => state.screenTabs,
	(formData, screenTabs) => {
		if (formData !== null) {
			return {
				currentFormState: formData,
				currentScreenTabsState: screenTabs || stableEmptyScreenTabsArrray,
			};
		}
		return {
			currentFormState: stableEmpty,
			currentScreenTabsState: stableEmptyScreenTabsArrray,
		};
	},
);

export const useCurrentFormState: HookStateFunction<CurrentPublicState> = createStateHook(store, {
	selector: selectCurrentFormState,
});
